var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center"},[_c('div',[_c('vs-pagination',_vm._g(_vm._b({attrs:{"max":_vm.paginationMax}},'vs-pagination',_vm.$attrs,false),_vm.$listeners))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }